// Services
import apiClient from '@/services/AccountClient'

export default {
  fetchAll (params = {}, options) {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/savings-accounts',
      params,
      options
    )
  },
  fetchById (id) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/savings-accounts/${id}`
    )
  },
  decline (id) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/savings-accounts/${id}/decline`
    )
  },
  fetchTransactions (id) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/savings-accounts/${id}/transactions`
    )
  },
  updateTransaction (savingsAccountId, transactionId, data) {
    return apiClient.sendRequest(
      'PUT',
      `api/admin/v1/savings-accounts/${savingsAccountId}/transactions/${transactionId}/update`,
      data
    )
  },
  declineTransaction (savingsAccountId, transactionId) {
    return apiClient.sendRequest(
      'DELETE',
      `api/admin/v1/savings-accounts/${savingsAccountId}/transactions/${transactionId}/decline`
    )
  },
  fetchRates () {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/savings-accounts/rates'
    )
  },
  saveRate (data) {
    return apiClient.sendRequest(
      'POST',
      'api/admin/v1/savings-accounts/rates',
      data
    )
  }
}
